import Image from 'next/image';
import { Text } from '@pairy/pds-react';
import Link from 'next/link';

const Pairy = () => {
  return (
    <>
      <Link href={'https://salesclue.io'} passHref>
        <a>
          <Image
            src="/images/salesclue_logo_white_alpha.png"
            width={133}
            height={31}
            priority
          />
        </a>
      </Link>
      <address>
        <Text as="p" color="zinc_400" variant="xs-medium" marginTop={16}>
          주식회사 내러티브
          <br />
          대표이사: 김인기
          <br />
          사업자번호 : 703-88-00878 l 통신판매업 신고번호 : 제
          2023-서울강남-04677 호<br />
          주소: 서울특별시 성동구 성수일로 10길 12, 406, 408호 (성수동2가,
          성수씨에프타워(성수CF-TOWER))
          <br />
          <br />
          Copyright @ 2025 SalesClue
        </Text>
      </address>
    </>
  );
};

export default Pairy;
